import { LocalStorageKeys } from '@/constants/LocalStorageKeys';
import IErrorLogMsg, { newErrorLogMsg } from '@/models/logging/IErrorLogMsg';
import DateTimeUtils from '@/utils/DateTimeUtils';
import HostUtils from '@/utils/HostUtils';
import theLocalStorageUtils from '@/utils/LocalStorageUtils';
import AuthTokenService from '../AuthTokenService';
import HostExchangeService from './HostExchangeService';
import IServiceHelper from './IServiceHelper';
import LogService from './LogService';
import TheConfigService from '../TheConfigService';
import TheWebEnvConfigService from '../TheWebEnvConfigService';

/**
 * This class allows the BaseApiService to indirectly use features of
 * it concrete implementations while avoiding circular dependency issues.
 * "TypeError: Class extends value undefined is not a constructor or null"
 */
export default class ServiceHelper implements IServiceHelper {
    async getAndSaveAuthToken(): Promise<boolean> {
        if (HostUtils.isTotal()) {
            const service = HostExchangeService.getInstance();
            const tokenData = await service.requestQuickSourceToken();
            if (tokenData) {
                theLocalStorageUtils.saveTokenData(tokenData);

                const durationMins = DateTimeUtils.getMinutesFromNow(tokenData.expires ?? '');
                //console.log(`ApiErrorHandler.getAndSaveAuthToken(), From host, Expiration[${tokenData.expires}], minutes[${durationMins?.minutes}]`);
                return true;
            }

            console.log(`ApiErrorHandler.getAndSaveAuthToken(), From host, Failed to get token. See prior message(s).`);
        } else if (HostUtils.isNone()) {
            const config = await TheConfigService.getInstance().getConfig();
            const webConfig = await TheWebEnvConfigService.getInstance().getConfigByHost();

            const service = new AuthTokenService(webConfig);
            //service.setLogRequest(true);

            const tokenData = await service.issueQuickSource(config.username, config.password);
            if (tokenData) {
                theLocalStorageUtils.saveTokenData(tokenData);

                const durationMins = DateTimeUtils.getMinutesFromNow(tokenData.expires ?? '');
                //console.log(`ApiErrorHandler.getAndSaveAuthToken(), From service, Expiration[${tokenData.expires}], minutes[${durationMins?.minutes}]`);
                return true;
            }

            console.log(`ApiErrorHandler.getAndSaveAuthToken(), From service, Failed to get token.`);
        } else {
            const productId = theLocalStorageUtils.get(LocalStorageKeys.callingProductId);
            console.log(`ApiErrorHandler.getAndSaveAuthToken(), Unknown host type[${productId}]`);
        }

        return false;
    }

    async saveErrorLog(httpResponseCode: number, message: string): Promise<void> {
        const qsGuid = theLocalStorageUtils.get(LocalStorageKeys.uuid);

        const errorMsg = newErrorLogMsg();
        errorMsg.httpResponseCode = httpResponseCode;
        errorMsg.message = message;
        errorMsg.dataString = qsGuid ?? '';

        const webEnvConfig = await TheWebEnvConfigService.getInstance().getConfigByHost();

        const service = new LogService(webEnvConfig);
        const success = await service.saveErrorLog(errorMsg);
        if (!success) {
            console.log('ApiErrorHandler.saveErrorLog(), Server error, Failed to log the error.');
        }
    }
}
